import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import DialogCustomTitle from '../../../../../components/DialogCustomTitle/DialogCustomTitle';
import { CRUDModes } from '../../../../../interfaces/CRUD';
import { SponsorPayment } from '../SponsorPayments.Interfaces';
import SponsorPaymentForm from './SponsorPaymentForm';

export interface SponsorPaymentFormProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  mode: CRUDModes;
  onSuccess: () => void;
  values?: SponsorPayment;
  closeFunction?: () => void;
}

const SponsorsPaymentPopup = ({
  open,
  setOpen,
  mode,
  onSuccess,
  values,
  closeFunction,
}: SponsorPaymentFormProps): JSX.Element => {
  return (
    <Dialog
      maxWidth='xl'
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
          if (closeFunction) closeFunction();
        }
      }}
    >
      <DialogCustomTitle
        onClose={() => {
          setOpen(false);
          if (closeFunction) closeFunction();
        }}
        mode={mode}
        title='pago'
      />
      <DialogContent>
        {open ? (
          <SponsorPaymentForm
            onSuccess={() => {
              setOpen(false);
              if (closeFunction) closeFunction();
              onSuccess();
            }}
            mode={mode}
            values={values}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default SponsorsPaymentPopup;
